// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_lPT","name":"Header_name__bSdpJ","birthday":"Header_birthday__3VVhp","skeleton":"Header_skeleton__234us"};